import { PrimaryFocus } from '../constant'

export const getProfileCenterPopoverDescription = (
  primaryFocus?: string,
  coOccurringDisorder?: string
): string => {
  if (coOccurringDisorder) {
    switch (primaryFocus) {
      case PrimaryFocus.SUBSTANCE_USE:
        return 'This center treats primary substance use disorders and co-occurring mental health conditions. Your treatment plan addresses each condition at once with personalized, compassionate care for comprehensive healing.'
      case PrimaryFocus.MENTAL_HEALTH:
        return 'This center specializes in primary mental health treatment and offers programs for co-occurring substance use. You receive collaborative, individualized treatment for whole-person healing.'
      default:
        return ''
    }
  }
  switch (primaryFocus) {
    case PrimaryFocus.SUBSTANCE_USE:
      return 'This center primarily treats substance use disorders, helping you stabilize, create relapse-prevention plans, and connect to compassionate support.'
    case PrimaryFocus.MENTAL_HEALTH:
      return 'At this center, you receive personalized care for mental health conditions. They provide therapy and tailor treatment to your unique needs, diagnoses, and preferences.'
    case PrimaryFocus.SUBSTANCE_USE_AND_MENTAL_HEALTH:
      return "You can admit to this center with a primary substance use disorder or a primary mental health condition. You'll receive support each step of the way and individualized care catered to your unique situation and diagnosis."
    case PrimaryFocus.EATING_DISORDERS:
      return 'You can get treatment for eating disorders at this center, helping you navigate symptoms, build coping tools, and restore your physical health under expert care.'
    case PrimaryFocus.BEHAVIORAL_ADDITION:
      return 'This center provides behavioral addiction treatment tailored to your unique concerns and symptoms, all in a supportive and compassionate environment.'
    case PrimaryFocus.WELLNESS:
      return "Centers with a wellness focus provide holistic care for the mind, body, and spirit. You'll often enjoy relaxing amenities and restorative activities tailored to rest and rejuvenation."
    case PrimaryFocus.AUTISM:
      return 'You receive personalized treatment for autism spectrum disorder at this center, led by experienced staff who support your journey from start to finish.'
  }

  return ''
}
